import * as React from "react";
import { useState, useEffect } from "react";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { PartLoading } from "../../../../../../react-core/Html/PartLoading";

import { Typography } from "../../../../../Shared/Typography/Typography";
import { AccountRoleStore } from "../Store/Variable";

interface ISectionTableProps {
    sectionHeader: string;
    columnConfigs: { title: string; data: any }[];
    onRef?: (func) => void;
    lightboxContent: (data, onDataChange) => JSX.Element | string;
    onSave?: (data) => boolean;
    onAdd?: (data) => boolean;
    onRemove?: VoidFunction;
    data: any;
    isLoading?: boolean;
    sectionHeaderCss?: string;
    cssWrapper?: string;
    extraButton?: JSX.Element | string;
    canEdit?: boolean;
}

export const SectionTable = (props: ISectionTableProps) => {
    const [lightbox, setLightbox] = useState(false);
    const [isEdit, setIsEdit] = useState(true);
    const [, setisRequested] = useState(false);

    const [data, setData] = useState(null);

    useEffect(() => {
        setData(JSON.parse(JSON.stringify(props.data)));
    }, [props.data]);

    useEffect(() => {
        if (!lightbox) {setData(JSON.parse(JSON.stringify(props.data)));}
    }, [lightbox]);

    useEffect(() => {
        if (props.onRef) {props.onRef(setLightbox);}
    }, []);

    const onDataChange = (changes, replace?: boolean) => {
        let _data = JSON.parse(JSON.stringify(data ? data : {}));
        if (replace) {
            _data = changes;
        } else {
            if (!_data) {_data = {};}
            for (const key in changes) {
                _data[key] = changes[key];
            }
        }
        setData(_data);
    };
    if (props.isLoading)
        {return (
            <div className="row">
                <div className="col-12">
                    <h3>{props.sectionHeader}</h3>
                    <PartLoading isLoading={true} />
                </div>
            </div>
        );}
    return (
        <div className={"section-table " + props.cssWrapper}>
            <div className="d-flex">
                <h3 className="pr-20">{props.sectionHeader}</h3>
                {props.onAdd && AccountRoleStore.canEditForAdv() && (
                    <button
                        className="add-button-secondary mt-4"
                        onClick={() => {
                            setLightbox(true);
                            setIsEdit(false);
                        }}
                    >
                        <span className="sr-only">{props.sectionHeader}</span>
                        <span className="icon" aria-hidden="true"></span>
                    </button>
                )}
            </div>

            <div className="def-list-wrapper">
                {props.onSave && <Typography wrapCss="mb-0" type="wider" config={props.columnConfigs} />}
                {AccountRoleStore.canEditForAdv() && (
                    <div className="buttons-wrapper">
                        {(props.canEdit == null || props.canEdit == true) && props.onSave && (
                            <button
                                className="edit-circle-icon-button mr-30"
                                title="Edit"
                                onClick={() => {
                                    setLightbox(true);
                                    setIsEdit(true);
                                    setisRequested(false);
                                }}
                            >
                                <span className="sr-only">Edit details</span>
                                <span className="icon" aria-hidden="true"></span>
                            </button>
                        )}
                        {(props.canEdit == null || props.canEdit == true) && props.onRemove && (
                            <button className="remove-button pl-0 pr-0 pb-0" onClick={() => props.onRemove()}>
                                <span className="sr-only">Remove details</span>
                                <span className="icon" aria-hidden="true"></span>
                            </button>
                        )}
                    </div>
                )}
            </div>

            {lightbox && (props.onAdd || props.onSave) ? (
                <Lightbox
                    cssWrapper="is-default-lightbox"
                    onClose={() => setLightbox(false)}
                    show={lightbox}
                    title={props.sectionHeader}
                    isClickOutsideClose={false}
                >
                    {props.lightboxContent(data, onDataChange)}
                    <div className="row">
                        <div className="col-auto">
                            <button
                                className="btn secondary"
                                onClick={() => {
                                    setLightbox(false);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                        <div className="col-auto">
                            <button
                                className="btn primary"
                                onClick={() => {
                                    if (isEdit) {
                                        if (props.onSave(data)) {setLightbox(false);}
                                    } else {
                                        if (props.onAdd(data)) {setLightbox(false);}
                                    }
                                }}
                            >
                                {isEdit ? "Save changes" : "Add"}
                            </button>
                        </div>
                        {props.extraButton && props.extraButton}
                    </div>
                </Lightbox>
            ) : null}
        </div>
    );
};
